import { Component } from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';

@Component({
  selector: 'app-calculation-field',
  templateUrl: './calculation-field.component.html',
  styleUrls: ['./calculation-field.component.scss']
})
export class CalculationFieldComponent extends FieldComponentAbstract {

  handleChange(data: string) {
    this.fieldValue.calculation = data;
    this.onChange(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/calculation-field/calculation-field.component.ts